import React from 'react';
import { AlertCircle } from 'lucide-react';

const SkepticsCorner = ({ points }) => {
  if (!points || points.length === 0) return null;

  // Handle both old format (strings) and new format (objects with concern/logic)
  const normalizedPoints = points.map(point => {
    if (typeof point === 'string') {
      return { concern: point, logic: null };
    }
    return point;
  });

  return (
    <div className="skeptics-corner rounded-r-xl p-5 mt-6" data-testid="skeptics-corner">
      <h4 className="text-amber-800 dark:text-amber-300 font-bold flex items-center gap-2 mb-3">
        <AlertCircle className="h-5 w-5" />
        Skeptic's Corner
      </h4>
      <p className="text-xs text-amber-700 dark:text-amber-400 mb-3">
        Critical considerations before accepting standard recommendations:
      </p>
      <ol className="space-y-3">
        {normalizedPoints.map((point, index) => (
          <li key={index} className="text-sm">
            <div className="flex gap-2 text-amber-900 dark:text-amber-200">
              <span className="font-bold text-amber-700 dark:text-amber-400 shrink-0">{index + 1}.</span>
              <div>
                <span className="font-medium">{point.concern}</span>
                {point.logic && (
                  <p className="text-amber-700 dark:text-amber-400 mt-1 text-xs leading-relaxed">
                    <span className="font-medium">Why it matters:</span> {point.logic}
                  </p>
                )}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default SkepticsCorner;
